// @flow

/**
 * Gets the closest ancestor that matches a selector string
 *
 * @param el {Element}
 * @param selector {string}
 * @returns {*}
 */

export function closest(el: Element, selector: string) {
	return el.closest(selector);
}

export type EventType =
	| MouseEventTypes
	| KeyboardEventTypes
	| FocusEventTypes
	| InputEventTypes
	| TouchEventTypes
	| ProgressEventTypes
	| 'change';

type DelegateEvent<TEvent: Event, TElement: Element> = TEvent & {
	delegateTarget: TElement,
};

type DelegateEventHandler<TEvent: Event, TElement: Element> = (
	event: DelegateEvent<TEvent, TElement>
) => void;

export function delegate<TElement: Element, TEvent: Event>(
	element: any,
	selector: string,
	type: EventType,
	callback: DelegateEventHandler<TEvent, TElement>,
	useCapture?: EventListenerOptionsOrUseCapture
) {
	let listenerFn = (e: any): void => {
		let delegateTarget = (e.target: Element).closest(selector);

		if (!delegateTarget) {
			return;
		}

		if ((e.currentTarget: Element).contains(delegateTarget)) {
			e.delegateTarget = delegateTarget;
			callback.call(element, (e: DelegateEvent<TEvent, TElement>));
		}
	};

	element.addEventListener(type, listenerFn, useCapture);

	return () => element.removeEventListener(type, listenerFn, useCapture);
}
